import React from "react";
import { SuburbAutocomplete } from "../../elements/SuburbAutocomplete";

export const EncasaSearch = () => {

  return (<div className="">
    <div className="">
      <SuburbAutocomplete />
    </div>
  </div>);
};